<div class="card-container row">
  <!-- General Information -->
  <div class="col-12 title">
    {{ "map.card.generalInformation" | translate }}
  </div>
  <table class="details-table">
    <tr>
      <td>
        <div>{{ "map.card.name" | translate }}:</div>
      </td>
      <td class="multi-content-cell">
        <mat-icon
          (click)="goToSite()"
          class="open-icon"
          aria-hidden="false"
          aria-label="link"
          fontIcon="outbound"
        ></mat-icon>
        <div>
          {{ this.site.descripcion
          }}<span class="code-text">{{ this.site.codigo }}</span>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.installationType" | translate }}:</div>
      </td>
      <td>
        <div>
          {{
            (site.codigoTipoInstalacion ?? "") == ""
              ? "-"
              : ("centro.installations." + site.codigoTipoInstalacion
                | translate)
          }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.activityType" | translate }}:</div>
      </td>
      <td>
        <div>
          {{
            (site.centro_Actividad_Codigo ?? "") == ""
              ? "-"
              : ("site.activity." + site.centro_Actividad_Codigo | translate)
          }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.location" | translate }}:</div>
      </td>
      <td>
        <div>
          {{
            (site.provincia ? site.provincia : site.ciudad) == null
              ? "-"
              : site.provincia ?? site.ciudad
          }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.manager" | translate }}:</div>
      </td>
      <td>
        <div>
          {{
            (site.responsable_Planta_Nombre ?? "") == ""
              ? "-"
              : site.responsable_Planta_Nombre
          }}
        </div>
      </td>
    </tr>
    <!-- <tr>
      <td><div>{{ site.managerName }}</div></td>
      <td colspan="2"><app-person [name]="site.managerName" [email]="site.managerEmail"></app-person></td>
    </tr> -->
  </table>
  <!-- END General Information -->
  <!-- <hr class="separator" /> -->

  <!-- operation Information -->
  <!-- <div class="col-12 title">
    {{ "map.card.operationInformation" | translate }}
  </div>
  <table class="details-table">
    <tr>
      <td>
        <div>{{ "map.card.plantsType.suppliedPopulation" | translate }}:</div>
      </td>
      <td>
        <div>
          {{ (site.poblaAbaste ?? 0) == 0 ? "-" : site.poblaAbaste }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>
          {{ "map.card.plantsType.usePrimaryWaterPercent" | translate }}:
        </div>
      </td>
      <td>
        <div>
          {{ (site.usoPriPorc ?? 0) == 0 ? "-" : site.usoPriPorc }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>
          {{ "map.card.plantsType.useSecondaryWaterPercent" | translate }}:
        </div>
      </td>
      <td>
        <div>
          {{ (site.usoSecPorc ?? 0) == 0 ? "-" : site.usoSecPorc }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.plantsType.denitrification" | translate }}:</div>
      </td>
      <td>
        <div>
          {{ (site.desnitrificacion ?? 0) == 0 ? "-" : site.desnitrificacion }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.plantsType.anaerobicDigestion" | translate }}:</div>
      </td>
      <td>
        <div>
          {{
            (site.digestion_Anaerobia_Fango ?? 0) == 0
              ? "-"
              : site.digestion_Anaerobia_Fango
          }}
        </div>
      </td>
    </tr>
  </table> -->
  <!-- END operation Information -->
  <!-- <hr class="separator" /> -->
  <!-- Design Information -->
  <!-- <div class="col-12 title">
    {{ "map.card.designInformation" | translate }}
  </div>
  <table class="details-table">
    <tr>
      <td>
        <div>{{ "map.card.plantsType.equivalentPopulation" | translate }}:</div>
      </td>
      <td>
        <div>
          {{
            (site.habitantes_Equivalentes ?? 0) == 0
              ? "-"
              : (site.habitantes_Equivalentes | number)
          }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.plantsType.volumeDesign" | translate }}:</div>
      </td>
      <td>
        <div>
          {{
            (site.caudal_Diseno ?? 0) == 0 ? "-" : (site.caudal_Diseno | number)
          }}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div>{{ "map.card.plantsType.kmRedHealthy" | translate }}:</div>
      </td>
      <td>
        <div>
          {{ (site.kmRedSanea ?? 0) == 0 ? "-" : (site.kmRedSanea | number) }}
        </div>
      </td>
    </tr>
  </table> -->
  <!-- END Design Information -->
</div>
